/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  HTTP_INTERCEPTORS,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Provider } from '@angular/core';
import { ElioError, EsuiteErrorResponse, toElioError } from '@elio/shared/models';
import { Observable, catchError, throwError } from 'rxjs';

const ERROR_KEY_PREFIX = 'error.';

const ESUITE_ERROR_CUSTOM_HANDLERS: Record<string, (esuiteError: EsuiteErrorResponse) => ElioError> = {
  ESUITE_PHP: (esuiteError: EsuiteErrorResponse) => {
    return new ElioError(esuiteError.code, ERROR_KEY_PREFIX + 'php.' + esuiteError.message);
  },
  INVALID_USE_CASE_RULE: (esuiteError: EsuiteErrorResponse) => {
    return new ElioError(esuiteError.code, ERROR_KEY_PREFIX + 'useCase.' + esuiteError.details['brokenRule']);
  },
};

export class ErrorInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(this.handleErrors);
  }

  handleErrors(source: Observable<HttpEvent<any>>): Observable<HttpEvent<any>> {
    return source.pipe(
      catchError((err: unknown) => {
        if (err instanceof HttpErrorResponse) {
          const esuiteErrorResponse: EsuiteErrorResponse | undefined = err.error;
          if (esuiteErrorResponse?.code) {
            if (ESUITE_ERROR_CUSTOM_HANDLERS[esuiteErrorResponse.code]) {
              return throwError(() => ESUITE_ERROR_CUSTOM_HANDLERS[esuiteErrorResponse.code](esuiteErrorResponse));
            }
            return throwError(
              () =>
                new ElioError(
                  esuiteErrorResponse.code,
                  ERROR_KEY_PREFIX + esuiteErrorResponse.code,
                  esuiteErrorResponse.details
                )
            );
          }
        }
        return throwError(() => toElioError(err));
      })
    );
  }
}

export const ERROR_INTERCEPTOR_PROVIDER: Provider = {
  provide: HTTP_INTERCEPTORS,
  useClass: ErrorInterceptor,
  multi: true,
};
